import React from 'react';
import ResultsEmptyStateIcon from '@assets/icons/table/results-empty-state.svg';

import { Header, ResultsEmptyStateWrapper, Subtitle } from './styled.tsx';

interface Props {
    header: string;
    subtitle: string;
}

const ResultsEmptyState: React.FC<Props> = ({ header, subtitle }) => (
    <ResultsEmptyStateWrapper>
        <ResultsEmptyStateIcon />
        <Header>{header}</Header>
        <Subtitle>{subtitle}</Subtitle>
    </ResultsEmptyStateWrapper>
);

export default ResultsEmptyState;
